import { EntityArchivedIcon } from '../../../Entity'
import { ICON_COLOR, ICON_HEIGHT_16, IconNG } from '../../../Icon'

import * as styles from './SelectDropdownEntityListItemIcons.module.css'

import SelectedIcon from '../../../../icons/done.svg'

function SelectDropdownEntityListItemIcons({
  children,
  isArchived,
  isSelected,
}) {
  if (!isArchived && !isSelected && !children) {
    return null
  }

  return (
    <div className={styles.icons}>
      {isArchived ? (
        <EntityArchivedIcon tooltip='Select.ArchivedItemkey' />
      ) : null}
      {isSelected ? (
        <IconNG
          Icon={SelectedIcon}
          color={ICON_COLOR.ButtonBg}
          size={ICON_HEIGHT_16}
        />
      ) : null}
      {children}
    </div>
  )
}

export default SelectDropdownEntityListItemIcons
